import createPlayer from '../../../shared/utils/create-player.js';

$(document).ready(() => {
  // Initialise youtube iframe api
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/iframe_api';
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = () => {
    $('[role="youtube-video-player"]').each(function (e) {
      const videoSection = $('[role="video-player"]', this)[0];

      if (videoSection) {
        const playButton = $(videoSection)
          .siblings('[role="video-play"]')
          .first();
        const overlay = $(videoSection)
          .siblings('[role="video-overlay"]')
          .first();

        const id = $(videoSection).data('id');
        const options = {
          controls: 0,
          loop: 1,
          playlist: id,
          autoplay: 0,
          mute: 1
        };

        createPlayer(videoSection, id, options).then((player) => {
          let started = false;

          // Hack to get the first frame - we pause on play event
          player.addEventListener('onStateChange', (e) => {
            if (e.data === 1 && !started) {
              player.pauseVideo();
              player.seekTo(1);
              started = true;
            }
          });

          player.playVideo();
          // Play video on play click event
          playButton.on('click', () => {
            // Play video, un-mute and start from beginning
            player.playVideo();
            player.unMute();
            player.seekTo(0);

            // Hide elements when play button clicked
            overlay.hide();
            playButton.hide();
          });
        });
      }
    });
  };
});
